import React from 'react';

const VARIANTS = {
  default: 'bg-[var(--axial-surface-elevated)] text-[var(--axial-text-primary)]',
  success: 'bg-[var(--axial-success)] text-white',
  warning: 'bg-[var(--axial-warning)] text-white',
  danger: 'bg-[var(--axial-danger)] text-white',
  info: 'bg-[var(--axial-info)] text-white',
};

function Badge({ children, variant = 'default', className = '' }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${VARIANTS[variant] || VARIANTS.default} ${className}`}>
      {children}
    </span>
  );
}

export default Badge;
